import canvas from '@classes/canvas'
import { MeterType } from '@constants/gauges_meters_consts'
import { degreesToRadians } from '@turf/helpers'

import { divideIfNotZero } from '../helper/canvasDraw'
import type { MainParams, StyleParams } from '../Meter'
import type { GaugeDrawResult } from './gauge_types'

export function drawSpeedGauge (mainParams: MainParams, styleParams: StyleParams): GaugeDrawResult {
  const { value, prevValue, maxValue, ctx, dpx, center, radius, unit, redraw, formatter, currentValue } = mainParams
  const { arcColor, color } = styleParams

  let progressAngle: number
  let newCurrentValue = currentValue

  const dd = degreesToRadians(270 / 100)
  const startAngle = degreesToRadians(135)
  const endAngle = degreesToRadians(270 + 135)

  const from = divideIfNotZero(Number(prevValue), Number(maxValue)) * 100
  const to = divideIfNotZero(100, Number(maxValue)) * Number(value)

  const drawing = (current: number) => {
    newCurrentValue = Number(Number(maxValue) * (current / 100))
    const value = ctx.measureText(formatter(newCurrentValue))
    const currentAngle = startAngle + dd * current
    progressAngle = currentAngle > endAngle ? endAngle : currentAngle

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    redraw()
    canvas.drawArc(ctx, center, center, radius - dpx * 4, startAngle, progressAngle, color || '#ffffff', dpx + 1)
    canvas.drawValue(
      ctx,
      center - Number(value.width) / newCurrentValue.toFixed(1).length - 4 * dpx,
      center,
      formatter(newCurrentValue),
      14 * dpx,
      color
    )
    unit
      && canvas.drawUnit(
        ctx,
        center + Number(value.width) / 2 + newCurrentValue.toFixed(1).length * dpx,
        center + dpx,
        unit,
        dpx * 9,
        color
      )
    canvas.drawArc(ctx, center, center, radius, startAngle - 3, endAngle, 'transparent', dpx + 1)
    canvas.drawArc(ctx, center, center, radius, startAngle, endAngle, arcColor, dpx + 1)
  }

  const animateId = canvas.animate(from, to, drawing, 1, MeterType.SPEED)

  return { animateId, newCurrentValue }
}
